import React from 'react';
import { bonuses } from '../data/resources';
import { siteConfig } from '../data/siteConfig';
import { CoverPending } from './CoverPending';
export function Bonuses() {
  return <section aria-labelledby="bonus-title" className="bg-blush px-5 sm:px-8 py-16 sm:py-24" data-id="element-27" data-mp="av352qvvf103">
      <div className="max-w-6xl mx-auto" data-id="element-28" data-mp="fu6cuj38jlbr">
        <div className="max-w-2xl" data-id="element-29" data-mp="ft4q3hcuxae7">
          <h2 id="bonus-title" className="font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-plum" data-id="element-30" data-mp="fs3dh8g70fud">
            4 bonussen om je creativiteit de ruimte te geven.
          </h2>
          <p className="mt-4 text-base sm:text-lg leading-relaxed text-ink/80" data-id="element-31" data-mp="5xbcrvrbdcvd">
            Ideeën voor decoraties, sleutelhangers, pennen en bedankjes, om nieuwe manieren te ontdekken om met punnikkoord te werken. Normaal {siteConfig.bonusOriginalPrice} per bonus, nu gratis bij het pakket.
          </p>
        </div>

        <div className="mt-12 sm:mt-16 space-y-8 sm:space-y-10" data-id="element-32" data-mp="1r9bh3rj0lrxh">
          {bonuses.map((bonus, i) => {
          const reversed = i % 2 === 1;
          return <article key={bonus.id} className="grid md:grid-cols-2 items-center rounded-[2rem] bg-cream overflow-hidden shadow-soft" data-id="element-33" data-mp="3id54x7cwv5bb" data-mpi={i}>
                <div className={`aspect-square ${reversed ? 'md:order-2' : ''}`} data-id="element-34" data-mp="3ddiroxx31p2i">
                  {bonus.image ? <img src={bonus.image} alt={bonus.imageAlt} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-35" data-mp="3r8ku3b2q0wak" /> : <CoverPending title={bonus.name} data-id="element-36" data-mp="2zfanq61mpnhu" />}
                </div>
                <div className="p-7 sm:p-10 lg:p-14" data-id="element-37" data-mp="2zhoj6g0811px">
                  <p className="font-serif text-lg font-semibold text-berry-deep" data-id="element-38" data-mp="2uhixrhkjobga">
                    Bonus {bonus.number}
                  </p>
                  <h3 className="mt-2 font-serif text-2xl sm:text-3xl font-semibold text-plum leading-snug break-words" data-id="element-39" data-mp="38e5wnpw25bou">
                    {bonus.name}
                  </h3>
                  <p className="mt-3 font-serif italic text-lg text-ink" data-id="element-40" data-mp="noggn9jmbjuk">{bonus.benefit}</p>
                  <p className="mt-4 text-base leading-relaxed text-ink/75 max-w-md" data-id="element-41" data-mp="iqexypq3tmjm">
                    {bonus.description}
                  </p>
                  <div className="mt-7 flex flex-wrap items-center gap-x-4 gap-y-3 border-t border-ink/10 pt-6" data-id="element-42" data-mp="3hhzofnyr6lgk">
                    <p className="flex items-baseline gap-3" data-id="element-43" data-mp="3lj32q615k9fo">
                      <s className="text-lg text-ink/60" data-id="element-44" data-mp="3lhi9cjqkqwje">
                        <span className="sr-only" data-id="element-45" data-mp="3qhmljxkg953t">Vorige prijs: </span>{siteConfig.bonusOriginalPrice}
                      </s>
                      <span className="font-serif text-3xl sm:text-4xl font-semibold text-berry-deep leading-none" data-id="element-46" data-mp="2tu9naaikr075">
                        <span className="sr-only" data-id="element-47" data-mp="2xrnszs71qpue">Nu: </span>€ 0
                      </span>
                    </p>
                    <span className="inline-flex items-center rounded-full bg-berry-deep px-3.5 py-1.5 text-sm font-semibold text-white" data-id="element-48" data-mp="37jjtf9wlus1s">
                      Vandaag gratis in het pakket
                    </span>
                  </div>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}